const PADDING = 12

export const calculateTooltipPosition = (
  selection: Selection | HTMLElement,
  tooltipWidth: number
) => {
  const mainEl = document.querySelector('main')

  const containerRect = mainEl.getBoundingClientRect()
  const scrollPosition = mainEl.scrollTop

  const selectionRect = (() => {
    if (selection instanceof HTMLElement) return selection?.getBoundingClientRect()

    return selection.getRangeAt(0)?.getBoundingClientRect()
  })()

  const relativePos = {
    left: selectionRect.left - containerRect.left,
  }

  const top = scrollPosition + selectionRect.top + selectionRect.height + 8 - containerRect.top

  const left = relativePos.left - tooltipWidth / 2 + selectionRect.width / 2

  const minLeft = PADDING
  const maxLeft = containerRect.width - tooltipWidth - PADDING

  const clampedLeft = Math.min(Math.max(left, minLeft), maxLeft)

  return { top, left: clampedLeft }
}
